export default {
  unrestricted: 'Sem restrição',
  lessThan: 'Menor que',
  moreThan: 'Maior que',
  between: 'Entre',
  exactly: 'Exatamente',
  mustBeLarger: 'Deve ser maior'
}
